import { httpBus } from "@/api/index.js";



/**
 * 获取当前正在使用的电价信息
 * @param {*} stationId 
 * @returns 
 */
export function queryElecPriceInUse(stationId) {
  const params = { stationId };
  return httpBus.request("get", "/dashboard/v2/income/price/query", {
    params,
  });
}



/**
 * 获取id对应的电价信息
 * @param {*} elecPriceId 
 * @returns 
 */
export function queryElecPriceInfoById(elecPriceId) {
  const params = { id: elecPriceId };
  return httpBus.request("get", "/dashboard/v2/income/price/query", {
    params,
  });
}



/**
 * 获取指定月份的国网电价
 * @param {*} stationId 
 * @param {*} month 
 * @returns 
 */
export async function queryGWElecPrice({stationId, month}) {
  const params = { stationId, month };
  const res = await httpBus.request("get", "/dashboard/v2/income/price/queryStateGrid", { params });
  
  // 过滤出需要的国网电价，并返回
  if (res?.data) {
    return res.data;
  } else {
    return null;
  }
}




/**
 * 创建电价
 * @param {*} params 
 * @returns 
 */
export function createElecPrice(params) {
  return httpBus.request("post", "/dashboard/v2/income/price/insert", {
    data: params,
  });
}



/**
 * 编辑电价
 * @param {*} params 
 * @returns 
 */
export function editElecPrice(params) {
  return httpBus.request("put", "/dashboard/v2/income/price/update", {
    data: params,
  });
}




/**
 * 获取电价的历史数据列表
 * @param {*} stationId 
 * @returns 
 */
export function queryHistoryElecPriceList(stationId) {
  const params = { stationId };
  return httpBus.request("get", "/dashboard/v2/income/price/queryPage", {
    params,
  });
}



/**
 * 操作电价：启用 or 弃用
 * @param {*} stationId 
 * @param {*} elecPriceId 
 * @param {*} operateType 4-启用 5-弃用
 * @returns 
 */
export function operateElecPriceStatus(stationId, elecPriceId, operateType) {
  const params = {
    stationId,
    id: elecPriceId,
    status: operateType,
  }
  return httpBus.request("put", "/dashboard/v2/income/price/operate", {
    data: params,
  });
}




/**
 * 检查当前电价是否与其他电价存在时间范围的重叠
 * @param {*} stationId 
 * @param {*} startDate 
 * @param {*} endDate 
 * @param {*} elecPriceId 
 * @returns true | false
 */
export function queryDateRangeIsOverlap({stationId, startDate, endDate, elecPriceId}) {
  const params = {
    stationId,
    startDate,
    endDate,
  };
  if (elecPriceId) {
    params['id'] = elecPriceId;
  }
  return httpBus.request("get", "/dashboard/v2/income/price/queryExist", {
    params,
  });
}

/**
 * 国网电价开关--查询
 * @param {*} stationId 
 * @returns 
 */
export function querySwitch(stationId) {
  const params = { stationId};
  return httpBus.request("get", "/dashboard/v2/income/price/switch/query", {
    params,
  });
}



/**
 * 国网电价开关--查询
 * @param {*} stationId 
 * @param {*} priceSwitch 
 * @returns 
 */
export function updateSwitch(stationId,priceSwitch) {
  const params = { stationId: stationId, priceSwitch:Number(priceSwitch)};
  return httpBus.request("put", "/dashboard/v2/income/price/switch/update", {
    data: params,
  });
}

/**
 * 查询省市行政区划
 * @returns
 */
export function queryProvinceCity() {
  return httpBus.request("get", "/schedule/job/weather/district/queryProvinceCity");
}

/**
 * 查询现货电价快照（按省份/站点）
 * @param {*} params
 * @param {*} params.areaCode
 * @param {*} params.priceDate
 * @param {*} params.priceType 1-实时 2-日前
 * @param {*} params.stationId
 * @returns
 */
export function querySpotSnapshotByArea(params) {
  return httpBus.request("get", "/dashboard/v3/price/snapshot/area", {
    params,
  });
}

/**
 * 批量保存现货电价快照（先删后增）
 * @param {*} data
 * @returns
 */
export function batchSaveSpotSnapshot(data) {
  return httpBus.request("post", "/dashboard/v3/price/snapshot/batch", {
    data,
  });
}

/**
 * 下载现货电价导入模板
 * @returns {Promise<Blob>}
 */
export function downloadSpotSnapshotTemplate() {
  return httpBus.request(
    "get",
    "/dashboard/v3/price/snapshot/importTemplate",
    {},
    { responseType: "blob" }
  );
}

/**
 * 导入现货电价
 * @param {*} file Excel 文件
 * @param {*} params 导入关联信息
 * @returns
 */
export function importSpotSnapshot(file, params = {}) {
  const formData = new FormData();
  formData.append("file", file);
  ["areaCode", "areaName", "priceType", "stationId"].forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, String(value));
    }
  });
  return httpBus.request("post", "/dashboard/v3/price/snapshot/import", {
    data: formData,
  }, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/**
 * 查询电站充电桩电价列表
 * @param {*} stationId
 * @param {*} type 1-储能 2-充电桩
 * @returns
 */
export function queryEnergyPriceByStation(stationId, type = 2) {
  return httpBus.request("get", `/dashboard/v3/price/energy/station/${stationId}`, {
    params: { type },
  });
}

/**
 * 新增电价（储能/充电桩）
 * @param {*} data
 * @returns
 */
export function createEnergyPrice(data) {
  return httpBus.request("post", "/dashboard/v3/price/energy", {
    data,
  });
}

/**
 * 修改电价（储能/充电桩）
 * @param {*} data
 * @returns
 */
export function updateEnergyPrice(data) {
  return httpBus.request("put", "/dashboard/v3/price/energy", {
    data,
  });
}
